export const FRONTEND_APP_VERSION_HEADER = 'x-fe-app-version';
